const PATH_PARAMS = {
  ERROR_CODE: 'errorCode'
} as const;

const ROUTES_PREFIX = {
  ERROR: '/error'
} as const;

export const SHARED_ROUTES = {
  NETWORK_ERROR: `${ROUTES_PREFIX.ERROR}/network`,
  LOGIN_ERROR: `${ROUTES_PREFIX.ERROR}/login`,
  SERVER_ERROR: `${ROUTES_PREFIX.ERROR}/server`,
  PILSNER_ERROR: `${ROUTES_PREFIX.ERROR}/pilsner/:${PATH_PARAMS.ERROR_CODE}`,
  UNDER_MAINTENANCE: `${ROUTES_PREFIX.ERROR}/under-maintenance`,
  INVALID_DEVICE: `${ROUTES_PREFIX.ERROR}/invalid-device`,
  FOREIGNER: `${ROUTES_PREFIX.ERROR}/foreigner`,

  INVALID_VERSION: `/invalid-version`,
  NOT_FOUND: `/not-found`
} as const;
